import React from 'react';
import { useTranslation } from 'react-i18next';
import { RelanceOnboardingConsent } from '../../components/RelanceOnboardingConsent/RelanceOnboardingConsent';
import { TranslationKey } from '../../i18n/translationKeys';
import { OnboardingHeader } from './OnboardingHeader';
import type { ScreenConsentProps } from './types';

export const ScreenConsent: React.FC<ScreenConsentProps> = ({ checked, onCheckedChange, onRefuseClick }) => {
    const { t } = useTranslation();

    return (
        <div data-testid="onboarding-screen-consent" className="flex flex-col items-center gap-xl w-full max-w-md">
            <OnboardingHeader
                title={t(TranslationKey.Onboarding.Consent.Title)}
                subtitle={t(TranslationKey.Onboarding.Consent.Subtitle)}
            />
            <RelanceOnboardingConsent checked={checked} onCheckedChange={onCheckedChange} onRefuseClick={onRefuseClick} />
        </div>
    );
};
